<template>
  <div>
    <Modal
      width="400px"
      v-model="modalOneShow"
      :mask-closable="false"
      :closable="false"
      :title="$t('guild-UsersManage-User38')"
      footer-hide
      class="visual-array-edit-model"
    >
      <p style="color:red">{{$t('WorkBench-Approve-Home93')}}</p>

      <div>
        <Tooltip placement="left" style="width: 100%;">
          <Input
            type="password"
            v-model="newPassword"
            style="margin-bottom:20px;"
            :placeholder="$t('Login-Register40')"
          >
            <template #prefix>
              <Icon type="ios-lock-outline" />
            </template>
          </Input>
          <template #content>
            <div class="tips">
              <h4>{{$t('tips-password-rule1') || '注： 密码需满足以下规则：'}}</h4>
              <br/>
              <p class="tips-item">1.{{$t('tips-password-rule2') || '8-20个字符'}}</p>
              <p class="tips-item">2.{{$t('tips-password-rule3') || '含以下选项中的三类即可：'}}</p>
              <p class="tips-item">a) {{$t('tips-password-rule4') || '英文小写字母（A-Z）'}}</p>
              <p class="tips-item">b) {{$t('tips-password-rule5') || '英文大写字母（a-z）'}}</p>
              <p class="tips-item">c) {{$t('tips-password-rule6') || '数字（0-9）'}}</p>
              <p class="tips-item">d) {{$t('tips-password-rule7') || '非字母数字符（如!$#%）'}}</p>
              <br/>
              <p class="tips-item tips-style">3.{{$t('tips-password-rule8') || '不能包含递增、递减、连续3个以上相同的数字或字符，如123，654，aaa,666'}}</p>
            </div>
          </template>
        </Tooltip>

      </div>
      <Input
        type="password"
        v-model="confirmPassword"
        style="margin-bottom:20px;"
        :placeholder="$t('WorkBench-Approve-Home70')"
      />
      <div
        class="array-edit-footer"
        style="text-align:right;"
      >
        <Button
          type="primary"
          style="margin-right:8px"
          @click="updatePassword"
        >{{$t('Common-CDialog1') || '确定'}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as society from 'http/api/society.js'
import { RSAencrypt } from 'assets/scripts/common'
let Base64 = require('js-base64').Base64
export default {
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      homeInfo: null,
      modalTwoShow: false,
      approveInfo: null,
    }
  },
  props: {
    modalOneShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 打开修改密码弹窗
    openModal () {
      this.oldPassword = '';
      this.newPassword = '';
      this.newPasswordAgain = '';
    },
    // 更新密码
    updatePassword () {
      if (this.newPassword === '') {
        this.$Message.warning(window.i18n.t('Layout-TopNav12'));
        return;
      } else if (this.confirmPassword === '') {
        this.$Message.warning(window.i18n.t('WorkBench-Approve-Home82'));
        return;
      } else if (this.newPassword !== this.confirmPassword) {
        this.$Message.warning(window.i18n.t('WorkBench-Approve-Home83'));
        return;
      }
      let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/;
      if (this.ruleValidate(this.newPassword) && this.modeValidate(this.newPassword)) {
        let params = {};
        // params.oldPassword =this.oldPassword;
        params.newPassword = this.newPassword;
        params.confirmPassword = this.confirmPassword;
        society.changePassword(JSON.stringify(RSAencrypt(params, true))).then(res => {
          if (res.rt.status == 200) {
            this.$Message.success(window.i18n.t('Layout-TopNav19'))
            this.$emit('cancelHandler')
            window.localStorage.removeItem('user')
            this.openModal();
            this.$emit('clearToken');
            this.$router.push({ path: '/login' });
          }
        }).catch(err => {
          console.log(err)
          this.$Modal.error(err)
        })
      } else {
        this.$Message.warning(window.i18n.t('Login-Forgot222'));
        // this.$Message.warning(window.i18n.t('Login-Forgot23') + '6-20' + window.i18n.t('Login-Forgot24') + '!');
      }
    },
    ruleValidate(str) {
      let count = 0
      let res = true
      let reg1 = /[A-Z]/
      let reg2 = /[a-z]/
      let reg3 = /[0-9]/
      let reg4 = /[^a-zA-Z0-9]/
      if (str == null || str.length < 8 || str.length > 20) {
          return false;
      }
      if(reg1.test(str)) count ++
      if(reg2.test(str)) count ++
      if(reg3.test(str)) count ++
      if(reg4.test(str)) count ++
      if(count < 3) {
        res = false
      }

      return res
    },
    modeValidate(str) {
      let res = true
      let arr = str.split('')
      let reg = /^[a-zA-Z0-9!@#$%^&*()_+-=]+$/
      let reg2 = /[^a-zA-Z0-9]/
      // if(!reg.test(str)) {
      //   res = false
      // }
      // 递增
      arr.forEach((item, index)=>{
        if(!reg2.test(item)) {
          if(str.charCodeAt(index + 1) == str.charCodeAt(index) + 1 && str.charCodeAt(index + 2) == str.charCodeAt(index) + 2) {
            res = false
            console.log('递增');
          }
        }
      })

      // 递减
      arr.forEach((item, index)=>{
        if(!reg2.test(item)) {
          if(str.charCodeAt(index + 1) == str.charCodeAt(index) - 1 && str.charCodeAt(index + 2) == str.charCodeAt(index) - 2) {
            res = false
            console.log('递减');
          }
        }
      })

      // 连续
      arr.forEach((item, index)=>{
        if(!reg2.test(item)) {
          if(str.charCodeAt(index + 1) == str.charCodeAt(index) && str.charCodeAt(index + 2) == str.charCodeAt(index)) {
            res = false
            console.log('连续');
          }
        }
      })

      return res
    }
  }
}
</script>

<style>
.ipass {
  background-position: 0 -52px;
}
.tips {
  width: 650px;
  max-width: 800px;
}
</style>
<style lang="less" scoped>
.tips {
  width: 600px;
  margin: 20px;
}
.tips-item {
  width: 500px;
  font-size: 12px;
  // color: #969696;
}
.tips-style {
  width: 500px;
  word-break: break-all;
  word-wrap: break-word;
}
/deep/.ivu-tooltip-inner {
  max-width: 600px !important
}
</style>
